import type { ModeFrais, NatureFrais } from '../shared'

export const NatureFraisAvecQuantite: Readonly<NatureFrais[]> = [] as const
export type NatureFraisAvecQuantite = (typeof NatureFraisAvecQuantite)[number]

export const NaturesFrais: { [key in ModeFrais]: Readonly<NatureFrais[]> } = {
  Annexe: ['Hebergement', 'Repas', 'Transport'],
  Pedagogique: [
    'Pedagogique',
    'ReperageAcquis',
    'EvaluationCompetences',
    'EvaluateurEntreprise',
    'JuryFraisCertification',
  ],
}

export const HelpFraisPedagogique: { [key in NatureFrais]?: string } = {
  Pedagogique: 'Formation, évaluation, accompagnement',
} as const

export const HelpFraisAnnexe: { [key in NatureFrais]?: string } = {} as const
